import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { I18nProvider } from "./i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import LegalPage from "./pages/LegalPage";
import ThankYou from "./pages/ThankYou";
import "./App.css";

// Wraps regular pages (with header/footer) and syncs <html lang>.
function SiteLayout({ children }) {
  const { pathname } = useLocation();
  const isEn = pathname.startsWith("/en");
  React.useEffect(() => {
    document.documentElement.lang = isEn ? "en" : "es-MX";
  }, [isEn]);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <div className="flex-1">{children}</div>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function LangRoutes({ children }) {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/mx" replace />} />
      <Route path="/thank_you" element={<ThankYou />} />

      <Route
        path="/mx"
        element={
          <SiteLayout>
            <Home />
          </SiteLayout>
        }
      />
      <Route
        path="/mx/privacidad"
        element={
          <SiteLayout>
            <LegalPage ns="privacy" testid="privacy-page" />
          </SiteLayout>
        }
      />
      <Route
        path="/mx/cookies"
        element={
          <SiteLayout>
            <LegalPage ns="cookiesPage" testid="cookies-page" />
          </SiteLayout>
        }
      />
      <Route
        path="/mx/terminos"
        element={
          <SiteLayout>
            <LegalPage ns="terms" testid="terms-page" />
          </SiteLayout>
        }
      />

      <Route
        path="/en"
        element={
          <SiteLayout>
            <Home />
          </SiteLayout>
        }
      />
      <Route
        path="/en/privacy"
        element={
          <SiteLayout>
            <LegalPage ns="privacy" testid="privacy-page" />
          </SiteLayout>
        }
      />
      <Route
        path="/en/cookies"
        element={
          <SiteLayout>
            <LegalPage ns="cookiesPage" testid="cookies-page" />
          </SiteLayout>
        }
      />
      <Route
        path="/en/terms"
        element={
          <SiteLayout>
            <LegalPage ns="terms" testid="terms-page" />
          </SiteLayout>
        }
      />

      <Route path="*" element={<Navigate to="/mx" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ScrollToTop />
        <LangRoutes />
      </I18nProvider>
    </BrowserRouter>
  );
}
